export const saveUser = (data, updateExpTime) => {
  localStorage.authenticationData = JSON.stringify(data);
  if (updateExpTime) {
    localStorage.expDate = (new Date()).getTime() / 1000 + data.authenticationData[0].exp;
    // localStorage.expDate = (new Date()).getTime() / 1000 + 60; // 1 minute
  }
};

export const addAccounts = newAccounts => {
  const existingAccounts = JSON.parse(localStorage.authenticationData).authenticationData;
  localStorage.authenticationData = JSON.stringify({ authenticationData: [...existingAccounts, ...newAccounts] });
};

export const clearToken = () => {
  localStorage.authenticationData = '';
  localStorage.expDate = '';
};
